module.exports = "<div id=\"alert\" class=\"lightbox lightbox-frame <%= containerClass %>\">\n    <div class=\"heading\">\n        <h3><%= title %> </h3>\n    </div>\n    <div class=\"alert-text-holder\">\n        <div class=\"alert-wrapper\">\n            <div class=\"alert-txt\">\n                <%= text %>\n            </div>\n        </div>\n    </div>\n    <div class=\"clear\"></div>\n    <div class=\"alert-btn-holder\">\n        <a href=\"#\" class=\"<%= buttonClass %> close-btn\"><%= buttonText %></a>\n    </div>\n    <div class=\"clear\"></div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./js/common/templates/Alert.html
// module id = 179
// module chunks = 25 26